import { createRoot } from 'react-dom/client'
import { Popup } from '@maptiler/sdk'
import { Button } from '@nazka/nazka.mapframe.components'
import { faTrashCan } from '@fortawesome/pro-light-svg-icons'

import './delete-popup.styl'

const getLngLat = (coordinates) => {
  if (Array.isArray(coordinates) && coordinates.length >= 2) {
    return [coordinates[0], coordinates[1]]
  }

  if (coordinates && typeof coordinates === 'object') {
    const { lng, lat } = coordinates
    if (typeof lng === 'number' && typeof lat === 'number') {
      return [lng, lat]
    }
  }

  return null
}

const DeletePopupContent = ({ onDelete, popup }) => {
  const handleDelete = () => {
    onDelete()
    popup.remove()
  }

  return (
    <div className="delete-popup">
      <p className="delete-popup__text">Delete this trap?</p>
      <div className="delete-popup__actions">
        <Button
          className="delete-popup__actions__button"
          iconProps={{ icon: faTrashCan }}
          onClick={handleDelete}
        >
          Delete
        </Button>
        <Button
          className="delete-popup__actions__button"
          onClick={() => popup.remove()}
        >
          Cancel
        </Button>
      </div>
    </div>
  )
}

const createDeletePopup = ({ map, coordinates, onDelete }) => {
  const lngLat = getLngLat(coordinates)
  if (!map || !lngLat) return null

  const container = document.createElement('div')
  const root = createRoot(container)

  const popup = new Popup()

  root.render(
    <DeletePopupContent popup={popup} onDelete={onDelete} />,
  )

  popup
    .setLngLat(lngLat)
    .setDOMContent(container)
    .addTo(map)

  popup.on('close', () => {
    root.unmount()
  })

  return popup
}

export default createDeletePopup
